// extracted by mini-css-extract-plugin
export var attribution = "_23-4";
export var authorName = "_23-5";
export var option = "_23-g";
export var optionCard = "_23-v";
export var optionContent = "_23-w";
export var optionGrid = "_23-12";
export var optionIcon = "_23-y";
export var optionIconBox = "_23-x";
export var optionLabel = "_23-z";
export var optionList = "_23-f";
export var optionPill = "_23-13";
export var optionPillBadge = "_23-16";
export var optionPillIcon = "_23-14";
export var optionPillLabel = "_23-15";
export var optionRadio = "_23-10";
export var optionRadioInner = "_23-11";
export var optionReveal = "_23-i";
export var optionRevealDelay0 = "_23-j";
export var optionRevealDelay1 = "_23-k";
export var optionRevealDelay10 = "_23-t";
export var optionRevealDelay11 = "_23-u";
export var optionRevealDelay2 = "_23-l";
export var optionRevealDelay3 = "_23-m";
export var optionRevealDelay4 = "_23-n";
export var optionRevealDelay5 = "_23-o";
export var optionRevealDelay6 = "_23-p";
export var optionRevealDelay7 = "_23-q";
export var optionRevealDelay8 = "_23-r";
export var optionRevealDelay9 = "_23-s";
export var optionSelected = "_23-h";
export var questionsBlock = "_23-18";
export var quote = "_23-3";
export var spacer = "_23-b";
export var stepCenteredContent = "_23-9";
export var stepInner = "_23-6";
export var stepInnerFullWidth = "_23-7";
export var stepInnerLockScroll = "_23-8";
export var stepTransitionFrame = "_23-a";
export var subtitle = "_23-e";
export var testimonial = "_23-2";
export var title = "_23-c";
export var titleWithAccessory = "_23-d";
export var trustedBy = "_23-0";
export var trustedByLabel = "_23-1";
export var welcomeBlock = "_23-17";